import classnames from 'classnames';
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { Icon, Button, message, Modal } from 'antd';
import { Link } from 'react-router-dom';
import routerCfg, { fillPathAppId } from 'routerCfg';
import extDisabled from 'extDisabled';
import useInstallState from 'useInstallState';
import getTT from 'getTT';
import styles from './style.scss?__local';
import imgExt from 'assets/img/ext_default.png';

const ColorStyles = {
  1: { background: 'linear-gradient(141deg, #25AAE5 0%, #338FDE 100%)' },
  2: { background: 'linear-gradient(141deg, #ff4d4f 0%, #ff7875 100%)' },
};

function App({ data, install }) {
  const ID = data?.extVersionType == 3 ? data.extUuid : (`${data.extUuid}-${data?.extVersionType == 4 ? data.extVersion : data.extVersionId}`)
  const ICON = data.extLogo ? (data.extLogo + '?x-oss-process=image/resize,limit_0,m_fill,w_152,h_152/sharpen,80/format,png/interlace,1/quality,q_90/rounded-corners,r_76') : imgExt

  function handle(key) {
    const value = data[key]
    return handlers[key] ? handlers[key](value) : value
  }


  const handlers = {
    extTypes(types) {
      const list = types && types.length ? types : []

      return list.map(item => <span key={item.typeTag}>{item.typeName}</span>)
    },
  }

  const renderTagList = (keywords) => {
    const tagListArr = keywords || []

    return (
      <div className={styles.tagsContent}>
        {
          tagListArr
            .slice(0, 3)
            .map((item, idx) => (
              <div className={styles.tagItem} key={`tag_${idx}`}>
                <div className={styles.tagText}>
                  <span className={styles.tagDesc}>{item}</span>
                </div>
              </div>
            ))
        }
      </div>
    )
  }

  const renderCorner = (badgeLabelInfo) => {
    // const cornerText = '限时免费';

    if (!badgeLabelInfo) return null;

    return (
      <div className={styles.corner} style={ColorStyles[`${badgeLabelInfo.color}`]}>
        <span className={styles.cornerText}>{badgeLabelInfo?.badgeLabel}</span>
      </div>
    )
  }

  return (
    <div className={classnames(styles.app, styles['app-type-' + data.extVersionType], { [styles.disabled]: extDisabled(data) })}>
      <Link className={styles.content} to={fillPathAppId(routerCfg.path.app, ID)}>
        <div className={styles.topInfo}>
          <div className={styles.media} title={data.extName}>
            <img src={ICON} alt={data.extName} />
          </div>

          <div className={styles.product}>
            <div className={styles.name}>
              <span className={styles.text} title={data.extName}>
                {data.extName + (extDisabled(data) ? '(已下架)' : '')}
              </span>
              {
                (data.extVersionType == 1 || data.extVersionType == 2 || data.extVersionType == 4) ?
                  (
                    <div className={styles.labels}>
                      <span className={classnames(styles.label, { [styles.labelAccess]: data.extVersionType === 4 })}>
                        {data.extVersionType === 1 ? '开发' : null}
                        {data.extVersionType === 2 ? '测试' : null}
                        {data.extVersionType === 4 ? '审核通过' : null}
                      </span>
                      <span className={classnames(styles.label, { [styles.labelAccess]: data.extVersionType === 4 })}>
                        {data.extVersion}
                      </span>
                    </div>
                  ) :
                  null
              }
            </div>

            {renderTagList(data.keywords)}

          </div>
        </div>

        {data.extBrief && (
          <div className={styles.brief} title={data.extBrief}>
            {data.extBrief}
          </div>
        )}
      </Link>
      <div className={styles.install}>
        <App.Install model={install} data={data} />
      </div>

      {renderCorner(data.badgeLabelInfo)}
    </div>
  )
}

App.Install = function ({ model, data: { extName, extUuid } }) {
  const [installState, setInstallState] = useInstallState(model)
  let [pending, setPending] = useState(false)

  useEffect(() => () => {
    setPending = () => { }
  }, [])

  const handleClick = () => {
    if (installState == 0) {
      Modal.confirm({
        title: `确定要移除“${extName}”么？`,
        content: '',
        okType: 'danger',
        onOk: toggle,
        autoFocusButton: null,
        cancelText: '取消',
        okText: '确定',
      })

      yaReportArr.push({
        eid: 'usr/click/appstore/iCenter/unstall',
        eid_desc: '小程序商店/我的/卸载',
        prop: JSON.stringify({
          extId: extUuid,
        }),
      })
    } else {
      getTT(TT => TT.sudo(toggle))
    }

    function toggle() {
      yaReportArr.push({
        eid: 'usr/click/appstore/iCenter/install',
        eid_desc: '小程序商店/我的/安装',
        prop: JSON.stringify({
          extId: extUuid,
        }),
      })

      setPending(true)

      model
        .toggle()
        .always(() => setPending(false))
        .fail(err => message.error(`${installState == 0 ? '移除' : '添加'}失败：${err}`))
    }
  }

  return (
    pending ?
      <App.Button.Loading /> :
      (
        installState == 0 ?
          <App.Button.Remove onClick={handleClick} /> :
          <App.Button.Add onClick={handleClick} />
      )
  )
}

App.Button = {
  Add({ onClick = () => { }, text = '添加' }) {
    return (
      <span className={classnames(styles.button, styles.add)} onClick={onClick}>
        <Icon type="plus" />
        <span>{text}</span>
      </span>
    )
  },
  Remove({ onClick = () => { }, text = '移除' }) {
    return (
      <span className={classnames(styles.button, styles.remove)} onClick={onClick}>
        {/* <Icon type="close" /> */}
        <span>{text}</span>
      </span>
    )
  },
  Loading() {
    return (
      <span className={classnames(styles.button, styles.loading)}>
        <Icon type="loading" />
      </span>
    )
  },
}

export default App
